export default __webpack_public_path__ + "static/media/Tus-seguros-en-un-solo-lugar.827600cf.svg";